import '../social_content_view.js.coffee'
Namespace 'Monitoring.Views.SocialContents.LinkedIn'

class Monitoring.Views.SocialContents.LinkedIn.LinkedInContentView extends
      Monitoring.Views.SocialContents.SocialContentView

  tagName: 'section'
  className: 'content linkedin expanded'

  events: ->
    return _.extend({}, Monitoring.Views.SocialContents.SocialContentView.prototype.events, {
      'click .toggle': 'togglePhoto'
    })

  togglePhoto: (event) =>
    @$el.toggleClass('collapsed expanded', 0)


  getHeaderView: (options) ->
    el = options.el
    model = options.model
    new Monitoring.Views.SocialContents.LinkedIn.LinkedInContentHeaderView(el, model)
